import { render, staticRenderFns } from "./receiptCreate.vue?vue&type=template&id=4d457445&scoped=true&lang=html&"
import script from "./receiptCreate.vue?vue&type=script&lang=js&"
export * from "./receiptCreate.vue?vue&type=script&lang=js&"
import style0 from "./receiptCreate.vue?vue&type=style&index=0&id=4d457445&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d457445",
  null
  
)

export default component.exports